import DescriptionIcon from '@material-ui/icons/Description';
import React from 'react';
import { AttachmentText, AttachmentLink, AttachmentWrapper } from './styledComponents';
import { dateFormatter, timeFormatter } from 'utils/helpers/date';
import { NoAssetsMessage } from '../../styledComponents';
import { useRecoilValue } from 'recoil';
import { caseAssetsState } from 'state/atoms';

const Attachments = () => {
  const { attachments = [] } = useRecoilValue(caseAssetsState);

  if (!attachments.length) {
    return <NoAssetsMessage>This case does not have attachments.</NoAssetsMessage>;
  }

  const getAttachmentName = (fullName = '') => {
    const name = fullName.slice(0, fullName.lastIndexOf('.'));
    const extension = fullName.slice(fullName.lastIndexOf('.'));

    if (name.length < 16) {
      return fullName;
    }

    return `${name.substr(0, 9)}...${name.slice(-3)}${extension}`;
  };

  const getAttachmentDate = (createdAt) => {
    const date = new Date(createdAt);
    return `${dateFormatter.format(date)} ${timeFormatter.format(date)}`;
  };

  return (
    <AttachmentWrapper>
      {attachments.map((attachment) => (
        <AttachmentLink
          key={attachment.url}
          href={attachment.url}
          title={attachment.name}
          target="_blank"
        >
          <DescriptionIcon />
          <AttachmentText>{getAttachmentName(attachment.name)}</AttachmentText>
          <AttachmentText>{getAttachmentDate(attachment.createdAt)}</AttachmentText>
        </AttachmentLink>
      ))}
    </AttachmentWrapper>
  );
};

export default Attachments;
